import './index.scss';
import classnames from 'classnames';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import DetailsPanel from './details_panel';
export const RecentActivityTabs = {
    DOCUMENTS: 'documents',
    DOCUMENT_COMPARISON: 'document-comparison',
};
const RightPanel = () => {
    const { tab: activeTab } = useParams();
    const { hasPermission } = useUser();
    const hasMultipleTabs = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENTS) &&
        hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS);
    const showRightPanel = hasPermission(Permissions.VIEW_RECENT_ACTIVITY_DOCUMENT_COMPARISONS) &&
        ((!hasMultipleTabs && activeTab === undefined) ||
            activeTab === RecentActivityTabs.DOCUMENT_COMPARISON);
    if (!showRightPanel)
        return React.createElement(React.Fragment, null);
    const containerClasses = classnames('right-panel-container', { 'tab-margin': hasMultipleTabs });
    return (React.createElement("div", { className: containerClasses },
        React.createElement(DetailsPanel, null)));
};
export default RightPanel;
